import { useQuery } from '@tanstack/react-query';

import { fetchChatRoomById } from '../api/routes';
import { useChatViewerRole } from './useChatViewerRole';

export const deepLinkChatRoomKey = (chatId: number, viewerRole: string) =>
  ['chat', 'room-by-id', chatId, viewerRole] as const;

/**
 * Загружает комнату по chatId из URL - в том числе из архива (active=false).
 */
export const useDeepLinkedChatRoom = (chatId: string | null, enabled: boolean) => {
  const viewerRole = useChatViewerRole();
  const chatIdNum = chatId ? parseInt(chatId, 10) : 0;

  return useQuery({
    queryKey: deepLinkChatRoomKey(chatIdNum, viewerRole),
    queryFn: () => fetchChatRoomById(chatIdNum, viewerRole),
    enabled: enabled && chatIdNum > 0,
    staleTime: 60_000,
    retry: 1,
  });
};
